import { __makeTemplateObject } from "tslib";
import styled from 'styled-components';
import { SVG } from '@at/design-system-elements';
import { ThemeSelectors } from '@at/design-system-foundation';
import { BulletIconColors } from './bullet-list.types';
var fillSelectorColor = function (theme, fillColor) {
    switch (fillColor) {
        case BulletIconColors.GREEN:
            return theme.color.icon.positive;
        case BulletIconColors.RED:
            return theme.color.icon.critical;
        case BulletIconColors.WHITE:
            return theme.color.text.intense.onFill;
        case BulletIconColors.COPY:
            return theme.color.text.default;
        case BulletIconColors.TITLE:
        default:
            return theme.color.icon.default;
    }
};
export var BulletList = styled.ul(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    list-style-type: none;\n    margin-top: ", ";\n    padding-left: ", ";\n\n    &.standard {\n        padding-left: 20px;\n\n        > li {\n            list-style-type: disc;\n            padding-left: ", ";\n        }\n    }\n"], ["\n    list-style-type: none;\n    margin-top: ", ";\n    padding-left: ", ";\n\n    &.standard {\n        padding-left: 20px;\n\n        > li {\n            list-style-type: disc;\n            padding-left: ", ";\n        }\n    }\n"])), function (_a) {
    var theme = _a.theme;
    return ThemeSelectors.getGroupFourSpacing(theme);
}, function (_a) {
    var theme = _a.theme;
    return ThemeSelectors.getGroupFiveSpacing(theme);
}, function (_a) {
    var theme = _a.theme;
    return ThemeSelectors.getGroupOneSpacing(theme);
});
export var BulletListOrdered = styled.ol(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    list-style-type: none;\n    margin-top: ", ";\n    padding-left: 20px;\n\n    > li {\n        list-style-type: decimal;\n        padding-left: ", ";\n    }\n"], ["\n    list-style-type: none;\n    margin-top: ", ";\n    padding-left: 20px;\n\n    > li {\n        list-style-type: decimal;\n        padding-left: ", ";\n    }\n"])), function (_a) {
    var theme = _a.theme;
    return ThemeSelectors.getGroupFourSpacing(theme);
}, function (_a) {
    var theme = _a.theme;
    return ThemeSelectors.getGroupOneSpacing(theme);
});
export var BulletListSVG = styled(SVG)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    left: ", ";\n    position: absolute;\n    top: 3px;\n\n    path {\n        fill: ", ";\n    }\n"], ["\n    left: ", ";\n    position: absolute;\n    top: 3px;\n\n    path {\n        fill: ", ";\n    }\n"])), function (_a) {
    var theme = _a.theme;
    return "calc( ".concat(ThemeSelectors.getGroupFiveSpacing(theme), " * -1)");
}, function (_a) {
    var theme = _a.theme, $fillColor = _a.$fillColor;
    return ($fillColor ? fillSelectorColor(theme, $fillColor) : 'currentcolor');
});
export var BulletListItem = styled.li(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    position: relative;\n    color: ", ";\n    margin-bottom: ", ";\n"], ["\n    position: relative;\n    color: ", ";\n    margin-bottom: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.color.text.intense.default;
}, function (_a) {
    var theme = _a.theme;
    return ThemeSelectors.getGroupTwoSpacing(theme);
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
